/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Callback_CrumbInputs */

const en_auth_callback_crumb = /** @type {(inputs: Auth_Callback_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in`)
};

/**
* | output |
* | --- |
* | "Signing in" |
*
* @param {Auth_Callback_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_callback_crumb = /** @type {((inputs?: Auth_Callback_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Callback_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_callback_crumb(inputs)
});